import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { showPermissionDenied } from '../stores/permission-denied.store';

interface PermissionDeniedGateProps {
  message?: string;
  redirectTo?: string;
}

/**
 * Shows the global permission-denied overlay and redirects away from a protected route.
 */
const PermissionDeniedGate: React.FC<PermissionDeniedGateProps> = ({
  message,
  redirectTo = '/',
}) => {
  useEffect(() => {
    showPermissionDenied(message);
  }, [message]);

  return <Navigate to={redirectTo} replace />;
};

export default PermissionDeniedGate;
